import styled from 'styled-components';

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const FormLabel = styled.label`
  cursor: pointer;
  color: var(--color-text-secondary);
  font-size: 14px;
  font-weight: bold;
  padding-left: var(--spacing-inner-base);
`;

export const Checkbox = styled.input``;